
import AbholungStartenLogic from "@/logic/bestellung_neu/abholung_starten_logic"
import Component, { mixins } from "vue-class-component"
import FilialeHeader from "../custom/FilialeHeader.vue"
import Bestellung from "@/entities/common/bestellung"
import router from "@/router"
import RouteNames from "@/util/route_names"
import Calculator from "../mixins/Calculator.vue"
import BestellungRow from "../custom/BestellungRow.vue"
import BestellungRowAbholung from "../custom/BestellungRowAbholung.vue"
import BestellungRowLieferung from "../custom/BestellungRowLieferung.vue"
import BestellungRowSofort from "../custom/BestellungRowSofort.vue"

@Component({
  components: {
    FilialeHeader,
    BestellungRow,
    BestellungRowAbholung,
    BestellungRowLieferung,
    BestellungRowSofort,
  },
})
export default class AbholungStarten extends mixins(Calculator) {
  logic: AbholungStartenLogic = null

  bestellungStarten() {
    this.logic.bestellungStarten()
  }

  mounted() {
    this.logic = new AbholungStartenLogic()
    this.logic.init()
  }

  bestellungAnzeigen(bestellung: Bestellung) {
    router.push({
      name: RouteNames.BESTELLUNG_PAGE.DETAILS,
      params: { bestellungId: bestellung.id },
    })
  }
}
